import React from 'react';
import { Heading, Stack } from '@grubhubprod/gh-cookbook-react';

type PageHeaderProps = {
  title: string;
};

export const PageTitle: React.FC<PageHeaderProps> = ({ title }) => {
  return (
    <Stack y="xxx-sm">
      <Heading variant="h1">{title}</Heading>
    </Stack>
  );
};
